module.exports = __webpack_public_path__ + "static/42-d610281b9ced142095f305afa1d84919.png";